export default {
    methods: {
        formatDecimalVariable (v) {
            if (typeof v === 'string' && v.indexOf(',') !== -1) {
                return Number(v.replace(',', '.'));
            } else if (typeof v === 'string') {
                return Number(v);
            }
            return v;
        }
    }
};
